const { REACT_APP_BIZ_WALLET_HOST } = process.env

const AutoPayCard = () => (
  <div className="ad_managebox">
    <div className="myinfo_cardinfo nodata_info">
      <p className="txt_nodata fw_bold">
        자동 결제 카드 정보는 비즈월렛의 내 결제 카드에서 조회 및 수정 할 수
        있습니다.
      </p>
      <a href={`${REACT_APP_BIZ_WALLET_HOST}/card`} className="btn_gb gm_bl">
        <span className="inner_g">내 결제 카드</span>
      </a>
    </div>
  </div>
)
export default AutoPayCard
